// French Language Pack
export default {
  // 检测部位
  part: {
    '车头': 'Avant',
    '发动机舱': 'Compartiment moteur',
    '左前车身': 'Carrosserie avant gauche',
    '左前内饰': 'Intérieur avant gauche',
    '左后车身': 'Carrosserie arrière gauche',
    '左后内饰': 'Intérieur arrière gauche',
    '车尾': 'Arrière',
    '后备箱内部': 'Intérieur du coffre',
    '右后车身': 'Carrosserie arrière droite',
    '右后内饰': 'Intérieur arrière droit',
    '右前车身': 'Carrosserie avant droite',
    '右前内饰': 'Intérieur avant droit',
    '机电': 'Électromécanique',
    '新能源检测': 'Inspection des véhicules à énergie nouvelle',
    '骨架': 'Structure du véhicule',
    '外观': 'Extérieur',
    '内饰': 'Intérieur',
    '其它': 'Autres',
    '其他': 'Autres',
    '水渍残留点': 'Traces d\'eau',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': 'Dommage léger',
    '严重损伤': 'Dommage grave',
    '预检异常': 'Anomalie de pré-inspection',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Aucun dommage dû à un accident sur les éléments structurels et de renfort du véhicule.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Pas de dommage dû à un accident sur les éléments structurels ; dommages légers dus à un accident sur les éléments de renfort.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Pas de dommage dû à un accident sur les éléments structurels ; dommages graves dus à un accident sur les éléments de renfort.',
    '车辆结构件有因事故造成的损伤': 'Présence de dommages dus à un accident sur les éléments structurels.',
    '外观极差': 'État extérieur extrêmement mauvais',
    '内饰极差': 'État intérieur extrêmement mauvais',
    '外观较差': 'État extérieur mauvais',
    '内饰较差': 'État intérieur mauvais',
    '外观一般': 'État extérieur moyen',
    '内饰一般': 'État intérieur moyen',
    '外观较好': 'État extérieur bon',
    '内饰较好': 'État intérieur bon',
    '外观准新': 'État extérieur quasi neuf',
    '内饰准新': 'État intérieur quasi neuf',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': 'Phare avant gauche',
    '左前雾灯': 'Antibrouillard avant gauche',
    '前底盘': 'Sous-châssis avant',
    '前保险杠': 'Pare-chocs avant',
    '中网': 'Calandre',
    '发动机舱盖外侧': 'Face extérieure du capot',
    '发动机舱盖内侧': 'Face intérieure du capot',
    '水箱框架': 'Cadre de radiateur',
    '前防撞梁': 'Poutre de pare-chocs avant',
    '左前纵梁': 'Longeron avant gauche',
    '左前翼子板骨架': 'Bavette d\'aile avant gauche',
    '左前减震器支座': 'Tour d\'amortisseur avant gauche',
    '防火墙': 'Tablier (cloison pare-feu)',
    '车架号': 'Numéro de châssis (VIN)',
    '右前减震器支座': 'Tour d\'amortisseur avant droit',
    '右前翼子板骨架': 'Bavette d\'aile avant droite',
    '右前纵梁': 'Longeron avant droit',
    '发动机变速箱及附件': 'Moteur, boîte de vitesses et accessoires',
    '机油': 'Huile moteur',
    '防冻液': 'Liquide de refroidissement',
    '刹车油': 'Liquide de frein',
    '电池': 'Batterie',
    '皮带': 'Courroie',
    '保险丝盒': 'Boîte à fusibles',
    '发动机线束': 'Faisceau moteur',
    '左前轮胎': 'Pneu avant gauche',
    '左前轮毂': 'Jante avant gauche',
    '左前避震器': 'Amortisseur avant gauche',
    '左前轮内衬罩': 'Garde-boue avant gauche',
    '左前翼子板': 'Aile avant gauche',
    '左后视镜': 'Rétroviseur gauche',
    '前风挡玻璃': 'Pare-brise avant',
    '左A柱外侧': 'Pilier A gauche extérieur',
    '左前车顶': 'Toit avant gauche',
    '左前门玻璃': 'Vitre de porte avant gauche',
    '左前门外侧': 'Panneau extérieur de porte avant gauche',
    '左前门裙边外侧': 'Bas de porte avant gauche extérieur',
    '左前门内侧': 'Panneau intérieur de porte avant gauche',
    '左前门内饰（含胶条）': 'Panneau de garniture de porte avant gauche (y compris joints)',
    '左A柱内侧': 'Pilier A gauche intérieur',
    '左前门裙边内侧': 'Bas de porte avant gauche intérieur',
    '主驾座椅区域': 'Zone du siège conducteur',
    '主驾座椅滑轨': 'Glissière du siège conducteur',
    '主驾安全带': 'Ceinture de sécurité conducteur',
    '左前地毯（含周边饰条、饰板）': 'Moquette avant gauche (y compris baguettes et panneaux environnants)',
    '转向管柱': 'Colonne de direction',
    '方向盘': 'Volant',
    '仪表盘': 'Combiné d\'instruments',
    '中控台': 'Console centrale',
    '前排扶手区域': 'Zone du repose-bras avant',
    '主驾仪表台': 'Planche de bord côté conducteur',
    '左A柱内饰板': 'Garniture du pilier A gauche',
    '左前顶棚（含前排天窗饰板、遮阳板）': 'Pavillon avant gauche (y compris garniture de toit ouvrant avant et pare-soleil)',
    '前排天窗': 'Toit ouvrant avant',
    '内后视镜区域': 'Zone du rétroviseur intérieur',
    '左后轮胎': 'Pneu arrière gauche',
    '左后轮毂': 'Jante arrière gauche',
    '左后避震器': 'Amortisseur arrière gauche',
    '左后轮内衬罩': 'Garde-boue arrière gauche',
    '左后翼子板': 'Aile arrière gauche',
    '左C柱外侧': 'Pilier C gauche extérieur',
    '左后车顶': 'Toit arrière gauche',
    '左B柱外侧': 'Pilier B gauche extérieur',
    '左后门玻璃': 'Vitre de porte arrière gauche',
    '左后门外侧': 'Panneau extérieur de porte arrière gauche',
    '左后门裙边外侧': 'Bas de porte arrière gauche extérieur',
    '左后门内侧': 'Panneau intérieur de porte arrière gauche',
    '左后门内饰（含胶条）': 'Panneau de garniture de porte arrière gauche (y compris joints)',
    '左C柱内侧': 'Pilier C gauche intérieur',
    '左B柱内侧': 'Pilier B gauche intérieur',
    '左后门裙边内侧': 'Bas de porte arrière gauche intérieur',
    '左后座椅区域': 'Zone du siège arrière gauche',
    '左后座椅滑轨': 'Glissière du siège arrière gauche',
    '左后安全带': 'Ceinture de sécurité arrière gauche',
    '左后地毯（含周边饰条、饰板）': 'Moquette arrière gauche (y compris baguettes et panneaux environnants)',
    '后排扶手区域': 'Zone du repose-bras arrière',
    '左B柱内饰板': 'Garniture du pilier B gauche',
    '左C柱内饰板': 'Garniture du pilier C gauche',
    '左后顶棚（含后排天窗饰板）': 'Pavillon arrière gauche (y compris garniture de toit ouvrant arrière)',
    '后排天窗': 'Toit ouvrant arrière',
    '后风挡玻璃': 'Lunette arrière',
    '左D柱外侧': 'Pilier D gauche extérieur',
    '右D柱外侧': 'Pilier D droit extérieur',
    '后备箱盖外侧': 'Face extérieure du couvercle de coffre',
    '左后尾灯': 'Feu arrière gauche',
    '右后尾灯': 'Feu arrière droit',
    '后保险杠': 'Pare-chocs arrière',
    '后防撞梁': 'Poutre de pare-chocs arrière',
    '左后纵梁': 'Longeron arrière gauche',
    '右后纵梁': 'Longeron arrière droit',
    '后底盘': 'Sous-châssis arrière',
    '后备箱盖内侧': 'Face intérieure du couvercle de coffre',
    '后备箱盖内饰板（含胶条）': 'Garniture du couvercle de coffre (y compris joints)',
    '后部导水槽': 'Gouttière d\'évacuation arrière',
    '左D柱内饰板': 'Garniture du pilier D gauche',
    '左D柱内侧': 'Pilier D gauche intérieur',
    '右D柱内饰板': 'Garniture du pilier D droit',
    '右D柱内侧': 'Pilier D droit intérieur',
    '后窗台板': 'Plage arrière',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': 'Garniture du coffre (y compris joints, moquette, baguettes et panneaux environnants)',
    '后围板': 'Tôle de cul arrière',
    '备胎轮胎': 'Roue de secours',
    '备胎轮毂': 'Jante de secours',
    '工具': 'Outillage',
    '后备箱底板': 'Plancher du coffre',
    '左后翼子板骨架(包含减震器支座)': 'Bavette d\'aile arrière gauche (y compris tour d\'amortisseur)',
    '右后翼子板骨架(包含减震器支座)': 'Bavette d\'aile arrière droite (y compris tour d\'amortisseur)',
    '右后轮胎': 'Pneu arrière droit',
    '右后轮毂': 'Jante arrière droite',
    '右后避震器': 'Amortisseur arrière droit',
    '右后轮内衬罩': 'Garde-boue arrière droit',
    '右后翼子板': 'Aile arrière droite',
    '右C柱外侧': 'Pilier C droit extérieur',
    '右后车顶': 'Toit arrière droit',
    '右B柱外侧': 'Pilier B droit extérieur',
    '右后门玻璃': 'Vitre de porte arrière droite',
    '右后门外侧': 'Panneau extérieur de porte arrière droite',
    '右后门裙边外侧': 'Bas de porte arrière droit extérieur',
    '右后门内侧': 'Panneau intérieur de porte arrière droite',
    '右后门内饰（含胶条）': 'Panneau de garniture de porte arrière droite (y compris joints)',
    '右C柱内侧': 'Pilier C droit intérieur',
    '右B柱内侧': 'Pilier B droit intérieur',
    '右后门裙边内侧': 'Bas de porte arrière droit intérieur',
    '右后座椅区域': 'Zone du siège arrière droit',
    '右后座椅滑轨': 'Glissière du siège arrière droit',
    '右后安全带': 'Ceinture de sécurité arrière droite',
    '右后地毯（含周边饰条、饰板）': 'Moquette arrière droite (y compris baguettes et panneaux environnants)',
    '右B柱内饰板': 'Garniture du pilier B droit',
    '右C柱内饰板': 'Garniture du pilier C droit',
    '右后顶棚': 'Pavillon arrière droit',
    '右A柱外侧': 'Pilier A droit extérieur',
    '右前车顶': 'Toit avant droit',
    '右前门玻璃': 'Vitre de porte avant droite',
    '右前门外侧': 'Panneau extérieur de porte avant droite',
    '右前门裙边外侧': 'Bas de porte avant droit extérieur',
    '右前门内侧': 'Panneau intérieur de porte avant droite',
    '右前门内饰（含胶条）': 'Panneau de garniture de porte avant droite (y compris joints)',
    '右A柱内侧': 'Pilier A droit intérieur',
    '右前门裙边内侧': 'Bas de porte avant droit intérieur',
    '副驾座椅区域': 'Zone du siège passager',
    '副驾座椅滑轨': 'Glissière du siège passager',
    '副驾安全带': 'Ceinture de sécurité passager',
    '右前地毯（含周边饰条、饰板）': 'Moquette avant droite (y compris baguettes et panneaux environnants)',
    '副驾仪表台': 'Planche de bord côté passager',
    '右A柱内饰板': 'Garniture du pilier A droit',
    '杂物箱': 'Boîte à gants',
    '右前顶棚（含前排天窗饰板、遮阳板）': 'Pavillon avant droit (y compris garniture de toit ouvrant avant et pare-soleil)',
    '右前轮胎': 'Pneu avant droit',
    '右前轮毂': 'Jante avant droite',
    '右前避震器': 'Amortisseur avant droit',
    '右前轮内衬罩': 'Garde-boue avant droit',
    '右前翼子板': 'Aile avant droite',
    '右后视镜': 'Rétroviseur droit',
    '右前大灯': 'Phare avant droit',
    '右前雾灯': 'Antibrouillard avant droit',
    '启动': 'Démarrage',
    '变速箱': 'Boîte de vitesses',
    '排烟': 'Fumée d\'échappement',
    '无钥匙进入': 'Entrée sans clé',
    '仪表盘功能自检': 'Autotest du combiné d\'instruments',
    '转向助力': 'Direction assistée',
    '电动后视镜功能': 'Fonction des rétroviseurs électriques',
    '中控锁': 'Verrouillage centralisé',
    '电动吸合门': 'Portes à fermeture assistée',
    '电动座椅': 'Sièges électriques',
    '座椅记忆': 'Mémoire de siège',
    '座椅加热': 'Sièges chauffants',
    '座椅通风': 'Ventilation des sièges',
    '座椅按摩': 'Massage des sièges',
    '主驾驶电动门窗总控': 'Commande principale des vitres côté conducteur',
    '灯光系统': 'Système d\'éclairage',
    '前驻车雷达': 'Radars de stationnement avant',
    '后驻车雷达': 'Radars de stationnement arrière',
    '倒车影像': 'Caméra de recul',
    '全景摄像头': 'Caméra panoramique',
    '可变悬架': 'Suspension adaptative',
    '车载冰箱': 'Réfrigérateur embarqué',
    '室内灯': 'Éclairage intérieur',
    '天窗': 'Toit ouvrant',
    '雨刷': 'Essuie-glaces',
    '多功能方向盘': 'Volant multifonctions',
    '方向盘换挡拨片': 'Palettes au volant',
    '方向盘加热': 'Volant chauffant',
    '方向盘记忆': 'Mémoire de position du volant',
    '空调': 'Climatisation',
    '电动门': 'Portes électriques',
    '电动车窗': 'Lève-vitres électriques',
    '后排电动遮阳帘': 'Pare-soleil électrique arrière',
    '后排液晶屏': 'Écran LCD arrière',
    '玻璃顶电动饰板': 'Garniture électrique de toit en verre',
    '硬顶敞篷': 'Cabriolet à toit rigide',
    '发动机': 'Moteur',
    '多媒体系统': 'Système multimédia',
    '动力电池包安装点': 'Points de fixation du bloc-batterie de traction',
    '动力电池包': 'Bloc-batterie de traction',
    '驱动电机(可见部分)': 'Moteur de traction (partie visible)',
    '逆变器(可见部分)': 'Onduleur (partie visible)',
    '车身高压线束(可见部分)': 'Faisceau haute tension de carrosserie (partie visible)',
    '随车充电枪': 'Câble de charge mobile',
    '车辆充电口': 'Prise de charge du véhicule',
    '增程器': 'Rallongeur d\'autonomie',
    '动力系统故障码': 'Code défaut du groupe motopropulseur',
    '车辆充电故障': 'Défaut de charge du véhicule',
  },

  // 缺陷名称
  defect: {
    '安装不良': 'Installation défectueuse',
    '常转': 'Fonctionne en continu',
    '超出上限': 'Au-dessus de la limite supérieure',
    '闯档': 'Passage de rapport brusque',
    '篡改': 'Falsification',
    '打齿异响': 'Bruit de grattement d\'engrenage',
    '打滑': 'Patinage',
    '打磨': 'Polissage',
    '灯内异物': 'Corps étranger dans le phare',
    '低于下限': 'Sous la limite inférieure',
    '断裂': 'Cassure',
    '钣金修复': 'Réparation de tôlerie',
    '改装': 'Modification',
    '更换': 'Remplacement',
    '功能失效': 'Hors service',
    '鼓包': 'Bosse',
    '故障': 'Défaut',
    '后打胶': 'Refixation du mastic à l\'arrière',
    '花屏': 'Distorsion de l\'écran',
    '划痕': 'Rayure',
    '划伤': 'Égratignure',
    '晃动': 'Jeu / vacillement',
    '变形': 'Déformation',
    '浑浊': 'Fluide trouble',
    '胶套损坏': 'Soufflet endommagé',
    '胶体异常': 'Mastic anormal',
    '胶条异常': 'Joint anormal',
    '卡滞': 'Coincement',
    '空转': 'Rotation à vide',
    '老化': 'Vieillissement',
    '裂纹': 'Fissure',
    '冒白烟': 'Fumée blanche',
    '冒黑烟': 'Fumée noire',
    '不出风': 'Pas de flux d\'air',
    '冒蓝烟': 'Fumée bleue',
    '霉斑': 'Taches de moisissure',
    '磨损': 'Usure',
    '泥沙': 'Boue et sable',
    '喷漆': 'Repeinture',
    '偏磨': 'Usure inégale',
    '破裂': 'Rupture',
    '破损': 'Dommage',
    '启动困难': 'Démarrage difficile',
    '气囊爆裂': 'Déploiement de l\'airbag',
    '不跳档': 'Ne passe pas les vitesses',
    '切割': 'Découpe',
    '缺失': 'Pièce manquante',
    '缺损': 'Éclat',
    '缺线': 'Faisceau manquant',
    '入档困难': 'Engagement de rapport difficile',
    '色差': 'Différence de teinte',
    '烧烫': 'Brûlure',
    '渗水': 'Infiltration d\'eau',
    '渗油': 'Suintement d\'huile',
    '失效': 'Hors fonction',
    '不制冷': 'Ne refroidit pas',
    '水雾': 'Buée',
    '松动': 'Desserrage',
    '松旷': 'Jeu excessif',
    '损坏': 'Casse',
    '损伤': 'Zone endommagée',
    '塌陷': 'Affaissement',
    '调节失效': 'Défaut de réglage',
    '贴膜起泡': 'Bulle sous le film',
    '脱档': 'Saut de vitesse',
    '污渍': 'Taches',
    '不走车': 'Le véhicule ne roule pas',
    '响应慢': 'Réponse lente',
    '修复': 'Réparation',
    '锈蚀': 'Corrosion',
    '异味': 'Odeur',
    '异响': 'Bruit anormal',
    '怠速不稳': 'Ralenti instable',
    '怠速过高': 'Ralenti trop élevé',
    '给不上油': 'Pas d\'alimentation en carburant',
    '加速抖动': 'Tremblement à l\'accélération',
    '缺缸': 'Raté d\'allumage (cylindre mort)',
    '部件缺失': 'Pièces manquantes',
    '气门异响': 'Bruit de soupapes',
    '内部异响': 'Bruit interne',
    '轮组异响': 'Bruit de roue',
    '窜气': 'Passage de gaz (blow-by)',
    '排气异响': 'Bruit d\'échappement',
    '水渍': 'Trace d\'eau',
    '凹陷': 'Enfoncement',
    '车门更换': 'Porte remplacée',
    '拆卸': 'Démontage',
    '后盖更换': 'Couvercle de coffre remplacé',
    '机盖更换': 'Capot remplacé',
    '内饰更换': 'Intérieur remplacé',
    '焊接': 'Soudure',
    '开裂': 'Fissuration',
    '剐蹭划伤': 'Éraflures et rayures',
    '渗漏': 'Fuite',
    '火烧': 'Brûlure par incendie',
    '抖动': 'Tremblement',
    '动力电池故障': 'Défaut du bloc-batterie de traction',
    '驱动电机故障': 'Défaut du moteur de traction',
    '其他': 'Autres',
    '快充故障': 'Défaut de charge rapide',
    '慢充故障': 'Défaut de charge lente',
    '过火': 'Traces de feu',
    '缺气': 'Pression d\'air insuffisante',
  },

  // 等级
  grade: {
    'A': 'Classe A',
    'B': 'Classe B',
    'C': 'Classe C',
    'D': 'Classe D',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': 'Aucune pièce extérieure remplacée',
    '外观原漆': 'Peinture d\'origine',
    '外观无需整备成本': 'Aucun coût de réfection extérieure',
    '内饰正常使用痕迹': 'Usure normale de l\'habitacle',
    '车辆无骨架损伤': 'Aucun dommage structurel',
    '发动机工况无异常': 'État du moteur normal',
    '变速器原地试车无异常': 'Essai stationnaire de la boîte de vitesses normal',
  },

  // 通用
  common: {
    '项': 'éléments',
    '项异常': 'éléments anormaux',
    '分': 'pts',
    '级': 'Classe',
    '检测': 'Inspection',
    '图片': 'Image',
    '加载失败': 'Échec du chargement',
    '加载中...': 'Chargement...',
  },

  // 页面标题
  title: {
    '车况检测': 'Inspection de l\'état du véhicule',
    '综合描述': 'Description générale',
    '综合': 'Global',
  },

  // 提示文案
  tips: {
    '源于出险数据': '(Issu des données de sinistres)',
    '车辆是否曾进水(漏水/涉水/水泡)': 'Le véhicule a-t-il déjà été exposé à l\'eau (fuite/gué/inondation) ?',
    '是': 'Oui',
    '否': 'Non',
    '查看原图': 'Voir l\'image originale',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': 'Règles de notation de l\'extérieur',
    '骨架评级规则': 'Règles d\'évaluation de la structure',
    '内饰评分规则': 'Règles de notation de l\'intérieur',
    '综合评级规则': 'Règles d\'évaluation globale',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': 'État extérieur quasi neuf',
    '外观较好': 'État extérieur bon',
    '外观一般': 'État extérieur moyen',
    '外观较差': 'État extérieur mauvais',
    '外观极差': 'État extérieur extrêmement mauvais',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': 'État intérieur quasi neuf',
    '内饰较好': 'État intérieur bon',
    '内饰一般': 'État intérieur moyen',
    '内饰较差': 'État intérieur mauvais',
    '内饰极差': 'État intérieur extrêmement mauvais',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Aucun dommage dû à un accident sur les éléments structurels et de renfort du véhicule.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Pas de dommage dû à un accident sur les éléments structurels ; dommages légers dus à un accident sur les éléments de renfort.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Pas de dommage dû à un accident sur les éléments structurels ; dommages graves dus à un accident sur les éléments de renfort.',
    '车辆结构件有因事故造成的损伤': 'Présence de dommages dus à un accident sur les éléments structurels.',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': 'Structure de catégorie ≥A, score extérieur ≥90, score intérieur ≥90 ; aucun remplacement, découpe, corrosion, boue, trace d\'eau, pièce manquante, moisissure, brûlure ni dommage des modules électromécaniques.',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': 'Structure de catégorie ≥A, score extérieur ≥80, score intérieur ≥80 ; pas de découpe, boue, trace d\'eau, moisissure, corrosion, etc.',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': 'Structure de catégorie ≥B, score extérieur >40, score intérieur >40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': 'Structure de catégorie ≥C, score extérieur ≥70, score intérieur ≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': 'Structure de catégorie ≥D, score extérieur ≥60, score intérieur ≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': 'Structure de catégorie ≥D, score extérieur ≥50, score intérieur ≥40 ; véhicule inondé non autorisé.',
    '骨架等级≥D，外观评分<50，内饰评分<40': 'Structure de catégorie ≥D, score extérieur <50, score intérieur <40',
  }
}
